import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import tournament from './tournament'
import userPool from './userPool'
import poolEntry from './poolEntry'
import gameResult from './gameResult'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user, userPool, tournament, poolEntry, gameResult
  }
})
